import { database } from './';
import { User } from '../types';

export function createUser(name: string) {
    const id = database.ref('users').push().key;
    const user = {
        id,
        name,
    };
    return database
        .ref(`users/${id}`)
        .set(user)
        .then(() => user);
}

export function getUser(id: string): Promise<User | null> {
    return database
        .ref('users')
        .child(id)
        .once('value')
        .then((dataSnapshot) => {
            return dataSnapshot.val();
        });
}
